module.exports = __webpack_public_path__ + "img/Ski-Road-sign.1e861eaa.jpg";